export const setupCopyToClipboard = function (parent) {
  const clips = parent.querySelectorAll('[data-copy-to-clipboard]')

  if (clips.length > 0) {
    clips.forEach(function (clip) {
      clip.addEventListener('click', function (e) {
        e.preventDefault()
        copyToClipboard(clip, e)
      })
    })
  }
}

async function copyToClipboard (clip, e) {
  try {
    await navigator.clipboard.writeText(clip.dataset.copyToClipboard)
    showCopiedPopup(clip)
  } catch (err) {
    console.error('Failed to copy URL: ', err)
  }
}

function showCopiedPopup (clip) {
  const notificationText = clip.getAttribute('data-copy-to-clipboard-notification') || 'Copied!'

  const popup = document.createElement('div')
  popup.className = 'social-sharing__copied-popup'
  popup.textContent = notificationText
  clip.appendChild(popup)

  setTimeout(() => {
    popup.remove()
  }, 2000)
}
